export default __webpack_public_path__ + "static/media/Logo_Full_Orange.2ae2c396.png";